import React from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import Icon from './Icon';
import Title from './Title';
import Summary from './Summary';

export default function Collapsed() {
  const user = useSelector(state => state.login.user || {});

  return _.isEmpty(user.mobile) ? (
    <>
      <Icon />
      <Title />
    </>
  ) : (
    <Summary user={user} />
  );
}
